import {
  ALL_SITES,
  DRAFT_CONFIGS,
  SELECTED_DRAFT_CONFIGS,
  SELECTED_SITE,
  SELECTED_TENANT_CONFIGS,
  TENANT_CONFIGS,
  SELECTED_EDITIOR_PREVIEW_SIZE,
  ALL_DYNAMIC_PAGES,
} from './actionTypes'

export const select_domain = (data) => {
  return { type: SELECTED_SITE, payload: data }
}

//
export const set_all_sites = (data) => {
  return { type: ALL_SITES, payload: data }
}
//
export const set_all_tenant_configs = (data) => {
  return { type: TENANT_CONFIGS, payload: data }
}
//
export const set_all_draft_configs = (data) => {
  return { type: DRAFT_CONFIGS, payload: data }
}
//
export const set_selected_tenant_configs = (data) => {
  return { type: SELECTED_TENANT_CONFIGS, payload: data }
}
//
export const set_selected_draft_configs = (data) => {
  return { type: SELECTED_DRAFT_CONFIGS, payload: data }
}
//
export const set_editor_preview_size = (data) => {
  return { type: SELECTED_EDITIOR_PREVIEW_SIZE, payload: data }
}
//
export const set_dynamic_pages = (data) => {
  return { type: ALL_DYNAMIC_PAGES, payload: data }
}
